<template>
  <div>
    <div class="modal fade" id="modal-technical-comment">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("common.comment") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div
                  v-if="technicalCommentList.length > 0"
                  style="border: 1px solid #dddddd; padding-top: 15px; padding-bottom: 15px;"
                >
                  <div class="comment-list-class">
                    <div
                      v-for="(item, index) in technicalCommentList"
                      :key="item + index"
                      class="comment-item-class"
                    >
                      <div>
                        <div class="user-created-class">
                          <small>{{ item.user_created_data.full_name }}</small>
                          <hr />
                        </div>
                        <div class="comment-content-item-class">
                          {{ item.content }}
                        </div>
                        <div class="file-comment-list">
                          <div
                            v-for="(fileItem, index) in item.img_list"
                            :key="fileItem + index"
                          >
                            <div v-if="fileItem.type === 1">
                              <img
                                id="apartment-img-id"
                                class="comment-content-item-img img-responsive"
                                :src="fileItem.url"
                                alt="apartment-img"
                                @click="onClickOpenAttachFile(fileItem.url)"
                              />
                            </div>
                            <div v-if="fileItem.type === 2">
                              <div
                                class="comment-content-item-img"
                                style="text-align: center;"
                                 @click="onClickOpenAttachFile(fileItem.url)"
                              >
                                <i
                                  class="fa fa-file-pdf-o"
                                  aria-hidden="true"
                                  style="font-size: xxx-large;"
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onPostCancelFeedback()"
            >
              {{ $t("common.confirm") }}
            </button> -->
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
    <!--  -->
    <div class="modal fade" id="modal-add-technical-comment">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="onCloseModalAddComment()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("common.comment") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="4"
                    v-model="technicalCommentContent"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div
                      class="class-border"
                      style="display: flex; justify-content: space-between; padding: 5px 10px;"
                    >
                      <span style="align-self: center;">{{
                        $t("userExtraInfo.attachFileList")
                      }}</span>
                      <div style="width: fit-content;">
                        <span
                          class="btn btn-primary"
                          style="padding: 2px 5px;"
                          @click="onClickAttachFile"
                          ><i class="fa fa-paperclip " aria-hidden="true"></i
                        ></span>
                        <span
                          class="btn btn-danger"
                          style="padding: 2px 5px;"
                          @click="onClickDeleteAttachFile"
                          ><i class="glyphicon glyphicon-trash"></i
                        ></span>
                      </div>
                    </div>
                    <div class="content-border-class attach-file-class">
                      <div
                        v-for="(attachFileItem, index) in attachFileList"
                        :key="attachFileItem + index"
                        style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: flex"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :id="index"
                          v-model="attachFileItem.enable"
                        />
                        <label
                          :title="attachFileItem.fileName"
                          class="form-check-label attach-file-name"
                          style="padding-left: 5px;"
                          @click="onClickOpenAttachFile(attachFileItem.pdfUrl)"
                        >
                          {{ attachFileItem.fileName }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div
                      class="class-border"
                      style="display: flex; justify-content: space-between; padding: 5px 10px;"
                    >
                      <span style="align-self: center;">{{
                        $t("banner.image")
                      }}</span>
                      <div style="width: fit-content;">
                        <span
                          class="btn btn-primary"
                          style="padding: 2px 5px;"
                          @click="onOpenInputSelectFile(imgList.length + 1)"
                          ><i class="fa fa-paperclip " aria-hidden="true"></i
                        ></span>
                      </div>
                    </div>
                    <div class="content-border-class attach-file-class">
                      <div
                        class="apartment-img-block"
                        v-for="(item, index) in imgList"
                        :key="item + index"
                      >
                        <img
                          id="apartment-img-id"
                          class="apartment-type-class img-responsive"
                          :src="item.url"
                          alt="apartment-img"
                        />
                        <div class="img-action">
                          <span
                            style="color: #006ad4"
                            class="action-button"
                            @click="onOpenInputSelectFile(index)"
                            ><small>{{ $t("common.update") }}</small></span
                          >
                          <span
                            style="color: #f2404d"
                            class="action-button"
                            @click="onclickRemoveImg(index)"
                            ><small>{{ $t("common.delete") }}</small></span
                          >
                        </div>
                      </div>
                    </div>
                    <div style="padding-top: 6px; text-align: center">
                      <input
                        class="img-upload-input"
                        :id="`upload-img-comment-input`"
                        type="file"
                        accept="image/*"
                        @change="handleClick"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onPostComment()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModalAddComment()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
    <!--  -->
    <component-file-pdf-with-file-name
      ref="componentFilePdfWithFileName"
      :titleModal="uploadPdfFileTitle"
      @uploadPdfFileEmit="handleUpdateAttachFileList"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
import axios from "axios";
//
import ComponentFilePdfWithFileName from "@/components/ComponentFilePdfWithFileName.vue";
export default {
  components: {
    loading: Loading,
    ComponentFilePdfWithFileName
  },
  data: () => ({
    isLoading: false,
    feedbackId: null,
    technicalCommentList: [],
    technicalCommentContent: null,
    //
    uploadPdfFileTitle: "",
    attachFileList: [],
    imgUploadIndex: 0,
    //
    imgList: [],
    imgUploadData: {
      url: null,
      size: null,
      file: null
    },
    media_server: {
      domain: "",
      token: ""
    }
    //
  }),
  watch: {
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    }
  },
  computed: {
    ...mapGetters([
      "GET_TOKEN_UPLOAD_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onShowModal: function() {
      $("#modal-technical-comment").modal("show");
    },
    onCloseModal: function() {
      $("#modal-technical-comment").modal("hide");
    },
    onGetData: function(feedbackId) {
      this.onShowModal();
      this.getFeedbackTechnicalComment(feedbackId);
    },
    getFeedbackTechnicalComment: function(feedbackId) {
      let filter = {
        params: {
          feedbackId: feedbackId
        }
      };
      this.GET_FEEDBACK_TECHNICAL_COMMENT_LIST(filter)
        .then(
          function(res) {
            this.isLoading = false;
            this.technicalCommentList = res;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            this.showError(mess);
            this.isLoading = false;
          }.bind(this)
        );
    },
    // add comment
    onShowModalAddComment: function() {
      $("#modal-add-technical-comment").modal("show");
    },
    onCloseModalAddComment: function() {
      $("#modal-add-technical-comment").modal("hide");
    },
    onShowAddComment: function(feedbackId) {
      this.onShowModalAddComment();
      this.feedbackId = feedbackId;
      this.technicalCommentContent = null;
      this.attachFileList = [];
      this.imgList = [];
      this.getTokenMedia();
    },
    onPostComment: function() {
      if (utils.isEmptyString(this.technicalCommentContent)) {
        this.showError(this.$t("feedback.content"));
      } else {
        let data = {
          id: this.feedbackId,
          content: this.technicalCommentContent,
          fileList: this.getFileList()
        };
        this.POST_FEEDBACK_TECHNICAL_COMMENT(data)
          .then(
            function() {
              this.isLoading = false;
              this.onCloseModalAddComment();
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              let mess = error.response.data.message;
              this.showError(mess);
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    //
    getTokenMedia: function() {
      this.GET_TOKEN_UPLOAD();
    },
    //
    onClickAttachFile: function() {
      let attachFileSelect = this.attachFileList.filter(x => x.enable === true);
      if (attachFileSelect.length === 0) {
        this.uploadPdfFileTitle = "common.addPdfFile";
        this.$refs.componentFilePdfWithFileName.onShowAddNew(
          this.attachFileList.length + 1
        );
      } else if (attachFileSelect.length === 1) {
        this.uploadPdfFileTitle = "common.updatePdfFile";
        this.$refs.componentFilePdfWithFileName.onShowDetail(
          attachFileSelect[0]
        );
      } else {
        this.showError();
      }
    },
    onClickDeleteAttachFile: function() {
      this.attachFileList = this.attachFileList.filter(x => x.enable === false);
    },
    onClickOpenAttachFile: function(url) {
      window.open(url);
    },
    handleUpdateAttachFileList: function(data) {
      let item = {
        id: data.id,
        pdfUrl: data.pdfUrl,
        fileName: data.fileName,
        index: data.index,
        enable: false
      };
      let searchIndex = this.attachFileList.findIndex(
        x => x.index === data.index
      );
      if (searchIndex === -1) {
        this.attachFileList.push(item);
      } else {
        this.attachFileList[searchIndex].id = item.id;
        this.attachFileList[searchIndex].pdfUrl = item.pdfUrl;
        this.attachFileList[searchIndex].fileName = item.fileName;
        this.attachFileList[searchIndex].enable = item.enable;
      }
    },
    //
    onClickImg: function() {
      let imgFileSelect = this.imgList.filter(x => x.enable === true);
      if (imgFileSelect.length === 0) {
        this.uploadPdfFileTitle = "common.addPdfFile";
        this.$refs.componentFilePdfWithFileName.onShowAddNew(
          this.imgList.length + 1
        );
      } else if (imgFileSelect.length === 1) {
        this.uploadPdfFileTitle = "common.updatePdfFile";
        this.$refs.componentFilePdfWithFileName.onShowDetail(imgFileSelect[0]);
      } else {
        this.showError();
      }
    },
    onOpenInputSelectFile: function(index) {
      this.imgUploadIndex = index;
      $(`#upload-img-comment-input`).val("");
      $(`#upload-img-comment-input`).click();
    },
    addAndUpdateImgList: function() {
      if (this.imgUploadIndex > this.imgList.length) {
        let item = {
          url: this.imgUploadData.url
        };
        this.imgList.push(item);
      } else {
        let imgListElement = this.imgList[this.imgUploadIndex];
        imgListElement.url = this.imgUploadData.url;
      }
    },
    onclickRemoveImg: function(index) {
      this.imgList.splice(index, 1);
    },
    handleClick: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.imgUploadData.size = files[0].size;
      await this.uploadImgFunction();
      await this.addAndUpdateImgList();
    },
    getResultFile: function(file) {
      let vm = this;
      vm.imgUploadData.file = file;
    },
    uploadImgFunction: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.imgUploadData.file);
        formData.append("directory", "homeMobileApp");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let imgUrl = res.data.domain + res.data.url;
              // let imgUrl = res.domain + res.url;
              this.imgUploadData.url = imgUrl;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getFileList: function() {
      let fileList = [];
      // img list
      this.imgList.forEach(data => {
        let item = {
          url: data.url,
          name: null,
          type: 1
        };
        fileList.push(item);
      });
      // attach file
      this.attachFileList.forEach(data => {
        let item = {
          url: data.pdfUrl,
          name: data.fileName,
          type: 2
        };
        fileList.push(item);
      });
      return fileList;
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_FEEDBACK_TECHNICAL_COMMENT_LIST",
      "POST_FEEDBACK_TECHNICAL_COMMENT",
      "GET_TOKEN_UPLOAD"
    ])
  }
};
</script>
<style scoped>
.comment-list-class {
  max-height: 300px;
  overflow: auto;
  padding: 10px;
  /* border: 1px solid #dddddd; */
}
.comment-item-class {
  border: 1px solid #dddddd;
  padding: 5px;
  margin-bottom: 10px;
  border-radius: 6px;
}
.user-created-class {
  text-align: right;
  color: blue;
}
.user-created-class hr {
  margin: 0;
  margin-bottom: 5px;
}
.comment-content-item-class {
  /* text-align: ; */
}

.file-comment-list {
  /* border: 1px solid #dddddd; */
}

.comment-content-item-img {
  margin: auto;
  /* width: 100%; */
  width: 70px;
  height: 70px;
  object-fit: contain;
  padding: 5px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 3%;
}
.comment-content-item-img:hover {
  cursor: pointer;
}

/*  */
/*  */
.class-border {
  border: 1px solid #cccccc;
}
.content-border-class {
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}
.attach-file-class {
  max-height: 150px;
  overflow: auto;
  padding: 10px;
}
.attach-file-name:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
/*  */
.img-upload-input {
  display: none;
  z-index: -9999;
}
.apartment-img-block {
  display: inline-block;
  margin-bottom: 15px;
}
.apartment-type-class {
  margin: auto;
  /* width: 100%; */
  width: 150px;
  height: 150px;
  object-fit: contain;
  padding: 10px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 3%;
}
.img-action {
  justify-content: space-between;
  display: flex;
  margin: 0 5px;
  padding: 0 5px;
}

.action-button:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/FeedbackTechnicalComment.vue